import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#33024A',
        secondary: '#C41735',
        anchor: '#8c9eff',
      },
    },
  },
})

export default vuetify